module.exports = __webpack_public_path__ + "img/chart_eidt_close.5b8d4222.svg";